import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { MedicalDevice } from "../../../Data/Art57Data/MedicalDevice";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicalDevice extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new MedicalDevice(new FieldDefinition(injector)),
        'Medical Device'
      );
      this.parent = parent;
      this.labelNodeName = 'Medical Device';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {

      if (this.data && this.data.model &&
        this.data.model.medicaldevicecode &&
        this.data.model.medicaldevicecode.value) {
          if (this.data.model.medicaldevicecode.name) {
            this.label = this.data.model.medicaldevicecode.name;                
          
          } else {
            this.ioc!.get(LookupGetService).getLookup('medicaldevice',this.data.model.medicaldevicecode.value)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.medicaldevicecode.name = result.name;
                this.refreshLabel();
              } else {
                this.label = this.labelTemplate;
              }
            });
          }   
        } else {
          this.label = this.labelTemplate;
        } 

    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeMedicalDevice = new TreeNodeMedicalDevice(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.medicaldevicecode &&
          this.data.model.medicaldevicecode.value
          ? this.data.model.medicaldevicecode.value
          : 'Not selected',
        this.data.model &&
          this.data.model.medicaldevicecode &&
          this.data.model.medicaldevicecode.name
          ? this.data.model.medicaldevicecode.name
          : this.label,
      ];
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }